module.exports = __webpack_public_path__ + "img/jiare.d8eaabb1.png";